import request from '@/utils/request'

//查询试卷
export function SelectPaper(params) {
    return request({
        url: '/api/Exam/Load',
        method: 'get',
        params
    })
}

//查询试卷详情
export function SelectDetailsPaper(params) {
    return request({
        url: '/api/Exam/Get',
        method: 'get',
        params
    })
}

//查询试卷题目详情
export function SelectPaperQuestion(params) {
    return request({
        url: '/api/Exam/GetOfficial',
        method: 'get',
        params
    })
}

//查询部门人员
export function getList(params) {
    return request({
        url: '/api/pmiUser/load',
        method: 'get',
        params
    })
}

//添加考试信息
export function AddExam(data) {
    return request({
        url: '/api/Exam/Add',
        method: 'post',
        data
    })
}

//添加考试人员
export function AddExamUser(data) {
    return request({
        url: '/api/ExamPeople/AddExamPeople',
        method: 'post',
        data
    })
}

//删除考试人员
export function DeleteExamUser(data) {
    return request({
        url: '/api/ExamPeople/Delete',
        method: 'post',
        data
    })
}

//修改考试人员
export function UpdateExamUser(data) {
    return request({
        url: '/api/ExamPeople/UpdateExamPeople',
        method: 'post',
        data
    })
}

//查询指定试卷
export function SelectPointExam(params) {
    return request({
        url: '/api/Exam/Get',
        method: 'get',
        params
    })
}

//修改试卷信息
export function UpdateExamInfo(data) {
    return request({
        url: '/api/Exam/Update',
        method: 'post',
        data
    })
}

//查询参加考试人员
export function SelectExamUser(params) {
    return request({
        url: '/api/ExamPeople/GetExamUser',
        method: 'get',
        params
    })
}

//批量加入
export function BatchAddition(params) {
    return request({
        url: '/api/ExamPeople/AddExamPeopleDept',
        method: 'get',
        params
    })
}

//获取改卷教官
export function SelectDrillMaster(params) {
    return request({
        url: '/api/Exam/GetCorrectUser',
        method: 'get',
        params
    })
}

//资源上传文件
export function uploadFile(data) {
    return request({
        url: '/resource/File/UploadFile',
        method: 'post',
        data
    })
}
